import { NoResultsWithButton } from "components";
import React, { useMemo } from "react";
import { CreateEmbeddedVideoButton } from "./CreateEmbeddedVideoButton";
import EmbeddedVideoIcon from "components/icons/EmbeddedVideoIcon";
import styles from "./EmbeddedVideosNoResults.module.scss";

export interface Props {
  filtered?: boolean;
  withActionBtn?: boolean;
}

export const EmbeddedVideoNoResults = (props: Props) => {
  const description = useMemo(
    () =>
      props.withActionBtn
        ? "Look like you don't have any embedded videos yet."
        : "Look like you don't have any videos yet.",
    [props.withActionBtn],
  );

  return (
    <NoResultsWithButton
      title="No embedded videos"
      description={description}
      actionText="Create one now using the button bellow."
      icon={<EmbeddedVideoIcon className={styles.evaNoResult} />}
      actionButton={props.withActionBtn && <CreateEmbeddedVideoButton />}
      filtered={props.filtered}
    />
  );
};
